import * as THREE from "three";

// UE/FBX exports often come in Z-up (length along Y). This lays the model flat,
// scales the footprint to `target` units and grounds it at y=0, centered.
export function normalizeFbx(fbx, target = 4.8) {
  const c = fbx.clone(true);
  let box = new THREE.Box3().setFromObject(c);
  let size = box.getSize(new THREE.Vector3());
  if (size.y >= Math.max(size.x, size.z)) {
    c.rotation.x = -Math.PI / 2;
  }
  c.updateMatrixWorld(true);
  box = new THREE.Box3().setFromObject(c);
  size = box.getSize(new THREE.Vector3());
  const s = target / Math.max(size.x, size.z);
  c.scale.setScalar(s);
  c.updateMatrixWorld(true);
  box = new THREE.Box3().setFromObject(c);
  const ctr = box.getCenter(new THREE.Vector3());
  c.position.sub(new THREE.Vector3(ctr.x, box.min.y, ctr.z));
  const wrapper = new THREE.Group();
  wrapper.add(c);
  wrapper.updateMatrixWorld(true);
  wrapper.userData.box = new THREE.Box3().setFromObject(wrapper);
  return wrapper;
}
